/**
 * Tracks browsing history in sessionStorage for history-based breadcrumbs.
 * Self-executing module — records the current page on every page load.
 */

const STORAGE_KEY = 'browsingHistory';
const MAX_ENTRIES = 10;

/**
 * @returns {{ url: string, title: string }[]}
 */
export function getHistory() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

function cleanTitle(title) {
  // Strip " – Shop Name" or " - Shop Name" or " | Shop Name" suffix
  const shopName = document.querySelector('meta[name="shop-name"]')?.content;
  if (shopName) {
    const suffixes = [` – ${shopName}`, ` - ${shopName}`, ` | ${shopName}`];
    for (const suffix of suffixes) {
      if (title.endsWith(suffix)) {
        return title.slice(0, -suffix.length);
      }
    }
  }
  return title;
}

function record() {
  const url = location.pathname;
  const title = cleanTitle(document.title);
  const history = getHistory();

  // Skip if same as last entry (page refresh)
  if (history.length > 0 && history[history.length - 1].url === url) {
    return;
  }

  // If URL exists earlier in history, truncate back to that point (back-button / revisit)
  const existingIndex = history.findIndex((entry) => entry.url === url);
  if (existingIndex !== -1) {
    history.length = existingIndex + 1;
    history[existingIndex].title = title;
  } else {
    history.push({ url, title });
  }

  // Cap at max entries
  const trimmed = history.slice(-MAX_ENTRIES);

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
  } catch {
    // sessionStorage full or unavailable — silently fail
  }
}

record();
